<template>

  <div class='EchartPractice'>
    <div :class="className"
         :id="id"
         :style="{width: '100%', height: '250px'}"></div>
  </div>
</template>

<script>
import * as echarts from 'echarts'
export default {
  name: 'echart-line',
  props: {
    className: {
      type: String,
      default: 'chart',
    },
    id: {
      type: String,
      default: 'chart',
    },
    titletop: {
      type: String,
    },
    itemsData: {
      type: Array,
    },
  },

  data() {
    return {
      chart: null,
      lineData: [],
    }
  },
  watch: {
    itemsData: {
      handler(newName, oldName) {
        if (oldName) {
          this.DrawBarChart()
        }
      },
      immediate: true,
      deep: true,
    },
  },
  mounted() {
    this.DrawBarChart()
  },
  methods: {
    DrawBarChart() {
      this.lineData = this.itemsData
      let yearData = []
      let ratingData = []
      //  console.log(this.lineData, 'line')
      for (let i = 0; i < this.lineData.length; i++) {
        yearData.push(this.lineData[i].LABEL)
        ratingData.push(this.lineData[i].VALUE)
      }

      if (yearData.length < 1) {
        return
      }
      this.chart = echarts.init(document.getElementById(this.id))

      // 调用showLoading方法
      this.chart.showLoading({
        text: 'loading',
        color: '#0084cd',
        textColor: '#0084cd',
        maskColor: 'rgba(255, 255, 255, 0.2)',
        zlevel: 0,
      })

      let option

      option = {
        title: {
          subtext: this.titletop,
        },
        tooltip: {
          trigger: 'item',
        },
        grid: {
          x: 70,
        },
        xAxis: {
          type: 'category',
          data: yearData,
          axisLabel: {
            interval: 0,
            rotate: 40,
          },
        },
        yAxis: {
          type: 'value',
        },
        series: [
          {
            data: ratingData,
            type: 'line',
          },
        ],
      }

      setTimeout(() => {
        this.chart.hideLoading()
        this.chart.setOption(option, true)
      }, 1000)
      //  this.chart.setOption(option)
    },
  },
}
</script>

<style lang="less" scoped>
.EchartPractice {
  width: 95%;
  margin: 0 auto;
}
</style>